import { ApiException, ConfigurationSettingsRequestDTO, ConfigurationSettingsResponseDTO, DeviceTwinResponse, ProblemDetails, ReportedTwinDTO, TransportConfigurationSettings } from "./ApiClient"
/** maps from generated type to type that represents the actual json */
export function ToTransport(t: ConfigurationSettingsResponseDTO): TransportConfigurationSettings {
    return {
        ...t,
        cloudEndpoint: t.cloudEndpoint ?? '',
        simulatorToRemoteIpMap: Object.fromEntries(
            Object.entries(t.simulatorToRemoteIpMap ?? {}).map(([key, setting]) =>
                [key, setting.Case === 'Eclypse' ?
                    {
                        type: setting.Case,
                        remoteIp: setting.Fields.remoteIp ?? '',
                        nLightId: ("nLightId" in setting.Fields ? setting.Fields.nLightId ?? '' : ''),
                        modemHostId: setting.Fields.modemHostId ?? ''
                    } :
                    {
                        type: setting.Case,
                        remoteIp: setting.Fields.remoteIp ?? '',
                        modemHostId: setting.Fields.modemHostId ?? '',
                    }]))
    }
}
/** maps from actual json and frontend type to type that the transport app api will understand */
export function ToRequest(t: TransportConfigurationSettings): ConfigurationSettingsRequestDTO {
    return {
        cloudEndpoint: t.cloudEndpoint,
        simulatorToRemoteIpMap: Object.fromEntries(
            Object.entries(t.simulatorToRemoteIpMap).map(([key, setting]) => [key, {
                Case: setting.type,
                Fields: { ...setting }
            }]))
    }
}
/** allows flowing type information about device twin response */
export function isSimple(x: DeviceTwinResponse): x is { Case: 'Simple', Fields: ReportedTwinDTO } { return x.Case === 'Simple' }
/** allows flowing type information about device twin response */
export function isComplete(x: DeviceTwinResponse): x is { Case: 'Complete', Fields: { item: string } } { return x.Case === 'Complete' }
/** allows flowing type information about device twin response */
export function isProblemDetails(x: any): x is ProblemDetails { return 'title' in x && 'status' in x && 'detail' in x }
